<template>
  <transition :appear="appear" name="v-fade--in">
    <div :class="cssClass" @click="closeBg">
      <div class="c-modal__inner">
        <div class="c-modal__content">
          <div class="c-modal-box" @click="clickBox">
            <div v-if="$slots.title" class="c-modal-box__header">
              <h2 class="c-modal-box__title"><slot name="title"></slot></h2>
              <Button
                v-if="!notClose && !notCloseBtn"
                class="c-modal-box__close"
                @click="close"
              >
                <i class="fas fa-times fa-lg"></i>
              </Button>
            </div>
            <div class="c-modal-box__content">
              <slot name="content"></slot>
            </div>
            <div v-if="$slots.footer" class="c-modal-box__footer">
              <slot name="footer"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Button from '@/components/Button';

export default {
  props: {
    appear: {
      type: Boolean,
      required: false
    },
    notClose: {
      type: Boolean,
      required: false
    },
    notCloseBg: {
      type: Boolean,
      required: false
    },
    notCloseBtn: {
      type: Boolean,
      required: false
    },
    size: {
      type: String,
      required: false
    }
  },
  components: {
    Button
  },
  computed: {
    cssClass() {
      return {
        'c-modal': true,
        ['c-modal--' + this.size]: this.size
      };
    }
  },
  mounted() {
    document.documentElement.classList.add('is-hidden');
  },
  destroyed() {
    document.documentElement.classList.remove('is-hidden');
  },
  methods: {
    clickBox(e) {
      e.stopPropagation();
    },
    close() {
      if (this.notClose) {
        return;
      }
      this.$emit('close');
    },
    closeBg() {
      if (this.notCloseBg) {
        return;
      }
      this.close();
    }
  }
};
</script>
